module.exports = require("./fr-CH");